import PortfolioHeading from './PortfolioHeading.component';

export default PortfolioHeading;
